import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-633aac80"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "image",
  src: "/img/not_found.jpg",
  alt: "Imagen no encontrada"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.fileName && _ctx.src[_ctx.fileName])
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "image",
          src: _ctx.src[_ctx.fileName],
          alt: `Imagen para alerta`
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("img", _hoisted_2))
  ]))
}